import moment from 'moment';
import { isWeekday } from '@/utilities/week';

export default {
  methods: {
    removeTimeFromDate(
      date,
      inputFormat = 'DD/MM/YYYY hh:mm:ss',
      outputFormat = 'DD/MM/YYYY'
    ) {
      const newDate = moment(date, inputFormat);

      if (!newDate.isValid()) {
        return '';
      }

      return newDate.format(outputFormat);
    },
    periodFormat(period) {
      //Para objetos tipo calcularUltimosMeses de service mixin
      const month = period.month < 10 ? `0${period.month}` : period.month;
      return `${period.year}${month}`;
    },
    /**
     * @param {number} months - Number of months
     * @returns {number} Equivalent number of years
     */
    calcYearsAndMonthsFromMonth(totalMonths) {
      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;
      let result = '';
      if (years > 0) {
        result += `${years} Año${years > 1 ? 's' : ''}`;
      }
      if (months > 0) {
        if (result) result += '  y ';
        result += `${months} Mes${months > 1 ? 'es' : ''}`;
      }
      return {
        text: result || '0 meses',
        months: months,
        years: years,
      };
    },

    /**
     * @returns {days:Number} Returns the number of business days from the first day of the current month to the current day
     *
     */
    countBusinessDaysUpToToday() {
      const today = moment();
      const startOfMonth = today.clone().startOf('month');
      return this.countBusinessDaysBetween(startOfMonth, today);
    },
    /**
     * @param {inputDate: String, inputDateFormat : String}
     * @returns {days:Number} Counts the number of business days (Monday to Friday)
     */
    countBusinessDaysInMonth(inputDate, inputDateFormat) {
      const date = moment(inputDate, inputDateFormat);
      const start = date.clone().startOf('month');
      const end = date.clone().endOf('month');
      return this.countBusinessDaysBetween(start, end);
    },
    /**
     * Counts the number of business days (Monday to Friday) between two dates (inclusive).
     * @param {moment.Moment} startDate - Start date of the range.
     * @param {moment.Moment} endDate - End date of the range.
     * @returns {number} - Number of business days between the dates.
     */
    countBusinessDaysBetween(startDate, endDate) {
      let current = startDate.clone();
      let count = 0;
      while (current.isSameOrBefore(endDate, 'day')) {
        if (isWeekday(current)) {
          count++;
        }
        current.add(1, 'day');
      }
      return count;
    },
    /**
     * Calculates how many full months have passed from a given date until today.
     * @param {String} dateString - The input date in string format.
     * @param {String} format - The expected format of the input date (default: 'YYYY-MM-DD').
     * @returns {Number|null} - Number of full months passed or null if the date is invalid.
     */
    countMonthsUpToToday(dateString, format = 'YYYY-MM-DD') {
      const inputDate = this.$moment(dateString, format);
      const today = this.$moment();

      if (!inputDate.isValid()) {
        return null;
      }
      const months = today.diff(inputDate, 'months');
      return {
        text: this.calcYearsAndMonthsFromMonth(months),
        months: months,
      };
    },

    /**
     * Formats a date into YYYYMMDD (year, month, day without separators)
     *
     * @param {String|Date} date - Date value (can be a Date object or a string like '2026-01-01')
     * @returns {String} Formatted date string (YYYYMMDD)
     */
    formatDateYYYYMMDD(date) {
      if (!date) return null;

      // Create a Date object from the received parameter
      const d = new Date(date + 'T00:00:00');
      if (isNaN(d)) return null;

      // Get the full year (YYYY)
      const year = d.getFullYear();

      // Get the month (0-based, so +1) and ensure 2 digits
      const month = String(d.getMonth() + 1).padStart(2, '0');

      // Get the day of the month and ensure 2 digits
      const day = String(d.getDate()).padStart(2, '0');

      // Return the final formatted date: YYYYMMDD
      return `${year}${month}${day}`;
    },
  },
};
